// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaire" mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence" largeur-formulaire="100"> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;